import { Box, Grid, LinearProgress } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import { Gridstyles } from '../ApplicationDetails';
import { useDispatch } from 'react-redux';
import { KeyValue } from '../ApplicationDetails/contributor';
import { AmcApprover } from '../../redux-store/types/api-types';
import {
  AmcApproverAccess,
  getAMCApproverById,
  getAmcApproverAccess,
} from '../../redux-store/actions/userManagement';
import { Location } from 'history';
import { BackButtonAndHeader } from './userBackButton';
import { AddressFieldReadonly } from './AddressFields';
import { styles } from '../../Styles/styles';

export default function AMCApproverDetails({
  location,
}: {
  location: Location<{ amcApproverId: number }>;
}): JSX.Element {
  const { amcApproverId: id } = location.state || { amcApproverId: null };
  const history = useHistory();
  const dispatch = useDispatch();
  const [isLoading, setLoading] = useState(false);

  const [amcApproverDetails, setAmcApproverDetails] = useState<AmcApprover>();
  const [accessForEditAdd, setAccessForEditAdd] = useState(false);

  useEffect(() => {
    let isComponentActive = true;
    (async function () {
      try {
        setLoading(true);
        const { amcApproverAccess } = (await dispatch(
          getAmcApproverAccess()
        )) as unknown as AmcApproverAccess;
        if (id) {
          const getAmcApproverDetails = (await dispatch(
            getAMCApproverById(id)
          )) as unknown as AmcApprover;
          setAmcApproverDetails(getAmcApproverDetails);
        }
        if (!isComponentActive) {
          return;
        }
        setAccessForEditAdd(amcApproverAccess);
        setLoading(false);
      } catch (e) {
        setLoading(false);
        console.error((e as Error).message);
      }
    })();
    return () => {
      isComponentActive = false;
    };
  }, []);

  return (
    <>
      <Box sx={styles.UsersFormikBox}>
        <BackButtonAndHeader
          User="AMC Approver"
          accessForEditAdd={accessForEditAdd}
          onClickBack={() => history.push('amc-approver')}
          onClickEdit={() =>
            history.push('edit-amcapprover', { amcApproverId: amcApproverDetails?.id })
          }
        />
        {isLoading ? (
          <LinearProgress sx={{ ml: 5, mr: 5 }} />
        ) : (
          amcApproverDetails && (
            <Grid container sx={{ mt: 1, pl: { xs: 2, sm: 10 }, pr: { xs: 2, sm: 10 }, pt: 1 }}>
              <React.Fragment>
                <Gridstyles>
                  <Grid
                    item
                    container
                    pb={5}
                    rowSpacing={6}
                    columnSpacing={13}
                    direction="row"
                    justifyContent="space-between"
                    alignItems="flex-start">
                    <KeyValue title={'Name'} description={amcApproverDetails.user.firstName} />
                    <KeyValue title={'Email Id'} description={amcApproverDetails.user.email} />
                    <KeyValue title={'Mobile Number'} description={amcApproverDetails.user.phone} />
                    <AddressFieldReadonly AddressField={amcApproverDetails} />
                  </Grid>
                </Gridstyles>
              </React.Fragment>
            </Grid>
          )
        )}
      </Box>
    </>
  );
}
